import React from "react";

const CaseLookup = () => <h1>Case Lookup</h1>;

export default CaseLookup;
